export default __webpack_public_path__ + "static/feature-preview-roadmap-4fd815e750b98b009864b2704b68b1b4.png";